import PsiPageTitle from "./PsiPageTitle.vue";

export { PsiPageTitle };
